<script>
	// Stores 
	import { textSite } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader from "../components/PageHeader.svelte";

   	// Code	
	let titlePage = 'Administração de Condomínios ';	
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container text-justify">
		<p>Na sua próxima reunião de Condomínio, não fale em despesas. Fale em economia com a Dinmar Imóveis.</p>
		<h2 class="title color-primary mt-35 mb-20 text-center">Atendimento Personalizado</h2>
		<ul>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Assessoria ao síndico</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Cobrança mensal dos valores devidos ao condomínio, através de DOC bancário emitido pela imobiliária</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Pagamento de todas as despesas do condomínio via transferências bancárias ou cheques emitidos pela imobiliária</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Prestação mensal de contas aos condôminos através de extratos detalhando receitas e despesas do período</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Entrega mensal de um balancete do condomínio, junto com toda a documentação que originou cada pagamento ou recebimento no período</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Elaboração de previsão orçamentária anual e assessoramento às assembleias gerais</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Elaboração e envio de editais para convocação de assembleias, de circulares, de notificações, de cartas e de outros documentos</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Cumprimento das rotinas da área de Recursos Humanos, tais como: Recrutamento, seleção, registro e pagamento do pessoal empregado do condomínio</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Recolhimento de todos os impostos, taxas e contribuições devidas pelo condomínio, ou que tenham sido retidas para recolher em nome de terceiros</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Auxiliar na contratação de seguros obrigatórios, na de fornecedores de materiais e na de prestadores de serviços</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Manter em arquivo pelo tempo legal e disponibilizar a fiscalizações ou condôminos, quando necessário, toda a documentação do condomínio</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Proceder a cobrança judicial das cotas e outros valores devidos ao condomínio, sem custo adicional, através de seus advogados</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Prestar assessoria jurídica no ramo do direito imobiliário, com ênfase nas questões do condomínio.</li>
		</ul>
		<h2 class="title color-primary mt-35 mb-20 text-center">O site da Dinmar também permite que nossos clientes, com o uso de senha:</h2>
		<ul>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Obter a 2ª via do documento para pagamento até a data do vencimento</li> 
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Consultar as contas do seu condomínio</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Adotem o sistema de débito em conta bancária</li>
			<li class="mb-10"><i class="fas fa-check-circle mr-10 color-primary"></i> Atualizem seus dados pessoais.</li>
		</ul>
		<hr>
		<p>Clique abaixo para solicitar uma proposta de serviços para o seu condomínio e descubra a diferença que é ter a nossa experiência trabalhando a favor de menores custos e mais qualidade nos serviços.</p>
		<div class="button mt-40 text-center">        
			<a href="/solicite-proposta" use:link replace title="" class="btn btn-secondary">
				Solicite uma proposta <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
			</a>
		</div>        

	</div>
</section>

<style type="text/sass">

.card-border
	padding: 20px
	display: flex
	align-items: center
	flex-direction: column
	h2
		font-size: 16px
	p 
		font-size: 12px
		line-height: 120%

</style>
